<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M13 13.5h1v-3h3v-1h-3v-3h-1v3h-3v1h3zM8.12 17q-.7 0-1.16-.46t-.46-1.16V4.62q0-.7.46-1.16T8.12 3h10.76q.7 0 1.16.46t.46 1.16v10.76q0 .7-.46 1.16t-1.16.46zm0-1h10.76q.24 0 .43-.2.2-.18.19-.42V4.62q0-.24-.2-.43a.6.6 0 0 0-.42-.19H8.12q-.24 0-.43.2a.6.6 0 0 0-.19.42v10.76q0 .24.2.43.18.2.42.19m-3 4q-.7 0-1.16-.46t-.46-1.16V6.62h1v11.76q0 .24.2.43.18.2.42.19h11.76v1z"
      />
    </svg>
  </span>
</template>
